import { GeneriskAction, GeneriskModel } from "./update";
import React, {Dispatch} from "react";
import { UIAction } from "../../update/ui";
import TransferList from "../FormComponents/TransferList";
import tw from "twin.macro";
import SingleObjectSelection from "../FormComponents/SingleObjectSelection";
import MultipleObjectSelection from "../FormComponents/MultipleObjectSelection";

interface ObjectSelectionProps {
  generiskState: GeneriskModel;
  generiskDispatch: Dispatch<GeneriskAction>;
  uiDispatch: Dispatch<UIAction>;
}

export default function ObjectSelection({
  generiskState,
  generiskDispatch,
  uiDispatch,
}: ObjectSelectionProps): JSX.Element | null {
  const selectedReportType = generiskState.selectedReportType.extract();

  if (!selectedReportType) {
    return null;
  }

  if (selectedReportType.feature === "ONE") {
    return (
      <>
        <h3 style={tw`text-xl font-bold text-left m-0 w-full`}>
          Velg objekttype
        </h3>
        <SingleObjectSelection
          state={generiskState}
          dispatch={generiskDispatch}
          uiDispatch={uiDispatch}
          vegobjekt={generiskState.selectedVegobjekt}
          onSelect={(type) =>
            generiskDispatch({
              type: "SelectOneVegobjekt",
              payload: type,
            })
          }
          title="Vegobjekttype"
        />
      </>
    );
  }

  if (selectedReportType.feature === "PRIMARY") {
    return (
      <MultipleObjectSelection
        state={generiskState}
        dispatch={generiskDispatch}
        uiDispatch={uiDispatch}
      />
    );
  }

  if (selectedReportType.feature === "MANY") {
    return (
      <TransferList
        title="Velg objekttyper"
        customReport={generiskState.customReport}
        updateAdditions={payload =>
          generiskDispatch({
            type: "UpdateCustomAdditions",
            payload,
          })
        }
        updateRemovals={payload =>
          generiskDispatch({
            type: "UpdateCustomRemovals",
            payload,
          })
        }
        resetSelections={() =>
          generiskDispatch({ type: "ResetTilvalg" })
        }
      />
    );
  }

  return null;
}
